import React, { useState } from 'react';

import styles from './styles.css';
import { Button, Image, Link, LinkButton, UIHeading3, useDeviceType } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { ETestIds } from '../../../../../../constants';
import { useTracking } from 'shared/mortgageMiniCalculator/utils/tracking/useTracking';
import { useSelector } from 'react-redux';
import { selectOfferForAnalytic } from '../../../../../../selectors/analytic/selectOfferForAnalytic';

export interface IPhoneButtonProps {
  text: string;
  phone: string;
}

const ICON_QR_CODE = 'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_mini_calculator/icons/qr-code.svg';

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ text, phone }) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  const [isShowPhone, setIsShowNumber] = useState(false);
  const offerForAnalytic = useSelector(selectOfferForAnalytic);
  const { trackClickOnShowPhone } = useTracking();

  const handleClick = () => {
    setIsShowNumber(true);
    trackClickOnShowPhone(offerForAnalytic);
  };

  if (isMobile) {
    return (
      <LinkButton
        href={`tel:${phone}`}
        onClick={() => trackClickOnShowPhone(offerForAnalytic)}
        fullWidth
        beforeIcon={<IconCommunicationPhone16 color={'icon-inverted-default'} />}
      >
        {text}
      </LinkButton>
    );
  }

  if (isShowPhone) {
    return (
      <div className={styles['phone-wrapper']}>
        <UIHeading3 color={'text-primary-default'}>
          <Link color={'current_color'} fontWeight={'bold'} href={`tel:${phone}`} data-testid={ETestIds.PhoneLink}>
            {phone}
          </Link>
        </UIHeading3>
        <div className={styles['qr-code-button']}>
          <div className={styles['qr-code-icon']}>
            <Image src={ICON_QR_CODE} alt={'qr-code'} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <Button onClick={handleClick} fullWidth data-testid={ETestIds.ShowPhoneButton}>
      {text}
    </Button>
  );
};

PhoneButton.displayName = 'PhoneButton';
